import * as Api from '../API/API.js';

import * as Helpers from '../Helpers/helpersFunc.js';

function NewlineText(props) {
  const text = props.text;
  return text.replace('\n\n', '\n').split('\n').map(str => <p>{str}</p>);
}

function NewsItem(props){

     
    return(
        
  <div className="newsItem"> 

  <div className="newsTitle">{props.title}</div>
  <div className="newsDate">{Helpers.isoStringToDateString(props.date)}</div>
  <div><img className="newsPhoto" src={Api.getImage(props.picture)} alt="" ></img></div>
  <div className="newsText"><NewlineText text={props.text}/></div>
</div>

    )
}

export default NewsItem;